import CompraView from "./CompraView";
export default CompraView;